import React, { useEffect, useRef, useState } from 'react';
import { BEEHIIV_LOADER_URL, BEEHIIV_FORM_ID } from '../lib/prelaunch';
import comeniusIcon from '../assets/images/comenius-mobile-icon-white.png';

export default function PrelaunchScreen() {
  const formRef = useRef<HTMLDivElement>(null);
  const [loadState, setLoadState] = useState<'loading' | 'ready' | 'error'>('loading');
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    const container = formRef.current;
    if (!container) return;
    // Guard against double-inject (StrictMode remount)
    const existing = container.querySelector('script[data-beehiiv-form]');
    if (existing) {
      setLoadState('ready');
      return;
    }
    const s = document.createElement('script');
    s.async = true;
    s.src = BEEHIIV_LOADER_URL;
    s.setAttribute('data-beehiiv-form', BEEHIIV_FORM_ID);
    s.onload = () => setLoadState('ready');
    s.onerror = () => setLoadState('error');
    container.appendChild(s);
  }, [retryKey]);

  return (
    <div
      data-testid="prelaunch-screen"
      className="h-full bg-bg-dark flex flex-col relative overflow-hidden"
    >
      <main className="flex-1 overflow-y-auto no-scrollbar px-6 pt-16 pb-10 flex flex-col items-center text-center">
        <img
          src={comeniusIcon}
          alt="Comenius"
          className="h-[72px] w-auto object-contain mb-6"
          referrerPolicy="no-referrer"
        />
        <p className="text-[10px] font-black uppercase tracking-[0.25em] text-primary mb-3">
          Private Beta
        </p>
        <h1 className="font-serif text-5xl text-white leading-[1.05] mb-4 max-w-[300px]">
          Opening 2027.
        </h1>
        <p className="text-white/70 text-sm leading-relaxed max-w-[300px] mb-8">
          Museum objects are coming alive in AR. Leave your email and we&apos;ll
          let you know when the doors open.
        </p>

        <div className="w-full max-w-[340px]">
          <div ref={formRef} className="min-h-[120px]">
            {loadState === 'loading' && (
              <div
                className="rounded-2xl border border-white/10 bg-white/5 p-5 animate-pulse"
                aria-label="Loading signup form"
              >
                <div className="h-11 rounded-xl bg-white/10 mb-3" />
                <div className="h-11 rounded-xl bg-primary/30" />
              </div>
            )}
          </div>
          {loadState === 'error' && (
            <button
              onClick={() => {
                setLoadState('loading');
                setRetryKey((k) => k + 1);
              }}
              className="mt-2 w-full h-12 rounded-xl border border-white/15 text-white/80 text-sm font-bold uppercase tracking-widest active:scale-[0.98] transition-all"
            >
              Reload signup form
            </button>
          )}
          <p className="mt-4 text-white/40 text-[11px] leading-relaxed">
            One email at launch. No spam.
          </p>
        </div>

        <div className="flex-1" />
      </main>
    </div>
  );
}
